import { CreditPurposeAmountPeriodBlockTexts } from '../CreditPurposeInfo.texts';

export const getAmountPeriodBlockTitle = (isCreditCardForm: boolean) =>
  isCreditCardForm ? CreditPurposeAmountPeriodBlockTexts.creditCard : CreditPurposeAmountPeriodBlockTexts.default;
